<!--
 * @Author: ���� 371824572@qq.com
 * @Date: 2024-06-18 09:06:14
 * @LastEditors: ���� 371824572@qq.com
 * @LastEditTime: 2024-06-28 09:54:26
 * @FilePath: \frontend\src\views\file\file.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div>
        <div>
            <el-row>
                <el-col :span="16">
                    <div class="grid-content bg-purple">
                        <el-input prefix-icon="el-icon-search" v-model="input" style="width: 300px;" placeholder="请输入内容"
                            @keyup.enter.native="handleQuery"></el-input>

                        <el-button type="primary" @click="handleQuery" style="margin-left: 20px;">查询</el-button>
                    </div>
                </el-col>
            </el-row>
            <div style="margin-top: 20px;">
                <el-table :data="fileData" border style="width: 100%">
                    <el-table-column prop="Number" label="档案号" width="150" :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column prop="Batch" label="年度" width="100" :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column prop="HospitalName" label="医疗机构名称" width="200" :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column prop="State" width="100" label="档案状态" align="center" :show-overflow-tooltip="true">
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.State === 1" effect="dark" type="info">未提交</el-tag>
                            <el-tag v-if="scope.row.State === 2" effect="dark" type="success">已提交</el-tag>
                            <el-tag v-if="scope.row.State === 3" effect="dark">未通过</el-tag>
                            <el-tag v-if="scope.row.State === 4" effect="dark" type="warning">已通过</el-tag>
                            <el-tag v-if="scope.row.State === 5" effect="dark" type="danger">已考核</el-tag>
                            <el-tag v-if="scope.row.State === 6" effect="dark" type="success">已归档</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="Score" label="得分" width="90" :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column prop="ScoreUserName" label="负责人" width="120" :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column prop="CreateTime" label="创建时间" width="200" :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column fixed="right" label="操作">
                        <template slot-scope="scope">
                            <el-button @click="handleClickDetail(scope.row)" type="text" size="small">查看详情</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <!--工具条-->
                <el-col :span="24" class="toolbar">
                    <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange"
                        :page-size="pageSize" :total="total" style="float: right"></el-pagination>
                </el-col>
            </div>
        </div>

        <!-- 查看模块详情弹出框 -->
        <el-dialog title="考核模块详情" v-if="moduleVisible"  :visible.sync="moduleVisible" 
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :before-close="moduleHandleClose" 
            width="90%" 
            :destroy-on-close="true"
            :fullscreen="true">
            <EvaluationAgency :fileManagermentPassId="fileManagermentPassId" :fileState="fileState"></EvaluationAgency>
        </el-dialog>
    </div>
</template>
<script>
import {
    getAssessmentFile
} from "../../api/file/file";
import EvaluationAgency from '../EvaluationAgency/EvaluationAgency.vue';
export default {
    components: { EvaluationAgency },
    data() {
        return {
            fileManagermentPassId:"",
            moduleInput:"",
            input: "",
            fileData: [],
            pageSize: 20,
            total: 0,
            pageIndex: 1,
            moduleVisible:false,
            fileState:"6"
        }
    },
    created() {
        this.handleQuery();
    },
    methods: {
        handleClickDetail(row)
        {
            this.moduleVisible=true;
            this.fileManagermentPassId=row.Id;
        },
        moduleHandleClose(done)
        {
            this.moduleVisible=false;
            this.moduleInput="";
            done();
        },
        handleQuery() {

            let parms = {
                HospitalId: this.$store.state.hospitalId,
                key: this.input,
                page: this.pageIndex,
                intPageSize: this.pageSize
            };
            getAssessmentFile(parms).then((res) => {
                if (res.success) {
                    this.fileData = res.response.data
                    this.total = res.response.dataCount
                    this.pageIndex = res.response.page
                    this.pageSize = res.response.PageSize
                }
            })
        },
        handleCurrentChange(val) {
            this.pageIndex = val;
            this.handleQuery();
        },
    }
}
</script>
<style  lang="less" scoped>
::v-deep .el-icon-close:before  {
    font-size: 30px !important;
}
</style>